<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {}
</style>



// WEBPACK FOOTER //
// src/App.vue